const perFile = {
  state: {
    messageObj: {
      isShow: true,
      message: '数据加载中...'
    },
    navArr: [],
    navArrDan: [],
    navArrFen: [],
    listArr: [],
    selectArr: [],
    openFolder: '',
    delFolderID: [],
    propertyObj: {},
    currentTreeNode: {},
    currentTreeNodeDan: {},
    currentTreeNodeFen: {},
    updateNodeListKey: 0,
    refreshFolderID: '',
    refreshKey: 0,
    uploadTypeKey: '',
    uploadTypeKeyFen: '',
    isShowShare: false,
    returnKey: 0,
    leftW: '',
    rightW: '',
    searchStatus: false,
    searchRow: {},
    timerKey: '',
    timerID: null,
    refreshSelectArr: [],
    packageIds: '',
    shareCol: false, // 点击就为true  // 搜索就为false
    moveAndCopy: false,
    copyMoveTitle: '',
    newFile: false
  },

  mutations: {
    PERFILE_NEWFILE(state, data) {
      state.newFile = data;
    },

    PERFILE_UPDATE_PACKAGEIDS(state, data) {
      state.packageIds = data;
    },

    PERFILE_SHARE_COL(state, data) {
      state.shareCol = data;
    },

    PERFILE_MOVE_AND_COPY(state, data) {
      state.moveAndCopy = data;
    },
    PERFILE_TITLE(state, data) {
      state.copyMoveTitle = data;
    },

    PERFILE_UPDATE_MESSAGE_OBJ(state, data) {
      state.messageObj = data;
    },

    PERFILE_UPDATE_NAV(state, data) {
      state.navArr = data;
    },
    PERFILE_UPDATE_NAV_DAN(state, data) {
      state.navArrDan = data;
    },
    PERFILE_UPDATE_NAV_FEN(state, data) {
      state.navArrFen = data;
    },

    PERFILE_UPDATE_LIST(state, data) {
      state.listArr = data;
    },

    PERFILE_UPDATE_SELECT (state, data) {
      state.selectArr = data;
    },

    PERFILE_OPEN_NODE_FOLDER(state, data) {
      state.openFolder = data;
    },

    PERFILE_DEL_LIST_ROW(state, data) {
      state.delFolderID = data;
      data.forEach((item) => {
        const index = state.listArr.findIndex((Item) => Item.folderID === item);
        if (index > -1) {
          state.listArr.splice(index, 1);
        }
        if (state.selectArr) {
          const Index = state.selectArr.findIndex(
            (Item) => Item.folderID === item
          );
          if (Index > -1) {
            state.selectArr.splice(index, 1);
          }
        }
      });
    },

    PERFILE_IS_SHOW_PROPERTY(state, data) {
      state.propertyObj = data;
    },

    PERFILE_UPDATE_TREE_NODE(state, data) {
      state.currentTreeNode = data;
    },
    PERFILE_UPDATE_TREE_NODE_DAN(state, data) {
      state.currentTreeNodeDan = data;
    },
    PERFILE_UPDATE_TREE_NODE_FEN(state, data) {
      state.currentTreeNodeFen = data;
    },
    PERFILE_UPDATE_NODE_LIST(state, data) {
      state.updateNodeListKey = new Date().getTime();
    },

    PERFILE_UPLOAD_SUCCEED(state, data) {
      state.refreshFolderID = data;
      state.refreshKey = new Date().getTime();
    },

    PERFILE_UPLOAD_TYPE(state, data) {
      state.uploadTypeKey = data;
    },
    PERFILE_UPLOAD_TYPE_FEN(state, data) {
      state.uploadTypeKeyFen = data;
    },
    PERFILE_IS_SHOW_SHARE(state, data) {
      state.isShowShare = !state.isShowShare;
    },

    PERFILE_NAV_RETURN(state) {
      state.returnKey = new Date().getTime();
    },

    PERFILE_UPDATE_LR_WIDTH(state, { lw, rw }) {
      state.leftW = lw;
      state.rightW = rw;
    },

    PERFILE_UPDATE_SEARCH_STATUS(state, data) {
      state.searchStatus = data;
    },

    PERFILE_UPDATE_SEARCH_ROW(state, data) {
      state.selectArr = [];
      state.searchRow = data;
    },

    PERFILE_UPDA_TETIMER_KEY(state) {
      state.timerKey = new Date().getTime();
    },

    PERFILE_UPDATE_TIMER_ID(state, data) {
      state.timerID = data;
    },

    PERFILE_UPDATE_SELECT_KEY(state, data) {
      state.refreshSelectArr = data;
    }
  },

  actions: {
    perFileNewFile({ commit }, data) {
      commit('PERFILE_NEWFILE', data);
    },

    PERFILEUPDATEPACKAGEIDS({ commit }, data) {
      commit('PERFILE_UPDATE_PACKAGEIDS', data);
    },
    perShareCol({ commit }, data) {
      commit('PERFILE_SHARE_COL', data);
    },

    perFileUpdateMessageObj({ commit }, data) {
      commit('PERFILE_UPDATE_MESSAGE_OBJ', data);
    },

    perFileUpdateNav({ commit }, data) {
      commit('PERFILE_UPDATE_NAV', data);
    },

    perFileUpdateNavDan({ commit }, data) {
      commit('PERFILE_UPDATE_NAV_DAN', data);
    },

    perFileUpdateNavFen({ commit }, data) {
      commit('PERFILE_UPDATE_NAV_FEN', data);
    },

    perFileMoveAndCopy({ commit }, data) {
      commit('PERFILE_MOVE_AND_COPY', data);
    },
    perFileTitle({ commit }, data) {
      commit('PERFILE_TITLE', data);
    },

    perFileUpdateList({ commit }, data) {
      commit('PERFILE_UPDATE_LIST', data);
    },

    perFileUpdateSelect ({ commit }, data) {
      commit('PERFILE_UPDATE_SELECT', data);
    },

    perFileOpenNodeFolder({ commit }, data) {
      data = { ...data };
      commit('PERFILE_OPEN_NODE_FOLDER', data);
    },
    perFileDelListRow({ commit }, data) {
      commit('PERFILE_DEL_LIST_ROW', data);
    },
    perFileIsShowProperty({ commit }, data) {
      commit('PERFILE_IS_SHOW_PROPERTY', data);
    },
    perFileUpdateTreeNode({ commit }, data) {
      commit('PERFILE_UPDATE_TREE_NODE', data);
    },
    perFileUpdateTreeNodeDan({ commit }, data) {
      commit('PERFILE_UPDATE_TREE_NODE_DAN', data);
    },
    perFileUpdateTreeNodeFen({ commit }, data) {
      commit('PERFILE_UPDATE_TREE_NODE_FEN', data);
    },
    perFileUpdateNodeList({ commit }, data) {
      commit('PERFILE_UPDATE_NODE_LIST', data);
    },

    perFileUploadSucceedCB({ commit }, data) {
      commit('PERFILE_UPLOAD_SUCCEED', data);
    },

    perFileUploadType({ commit }, data) {
      commit('PERFILE_UPLOAD_TYPE', data);
    },
    perFileUploadTypeFen({ commit }, data) {
      commit('PERFILE_UPLOAD_TYPE_FEN', data);
    },

    perFileIsShowShare({ commit }, data) {
      commit('PERFILE_IS_SHOW_SHARE', data);
    },

    perFileNavReturn({ commit }) {
      commit('PERFILE_NAV_RETURN');
    },

    perFileUpdateLRWidth({ commit }, data) {
      commit('PERFILE_UPDATE_LR_WIDTH', data);
    },

    perFileUpdateSearchStatus({ commit }, data) {
      commit('PERFILE_UPDATE_SEARCH_STATUS', data);
    },

    perFileUpdateSearchRow({ commit }, data) {
      commit('PERFILE_UPDATE_SEARCH_ROW', data);
    },

    perFileUpdateTimerKey({ commit }) {
      commit('PERFILE_UPDA_TETIMER_KEY');
    },

    perFileUpdateTimerID({ commit }, data) {
      commit('PERFILE_UPDATE_TIMER_ID', data);
    },

    perFileUpdateSelectKey({ commit }, data) {
      commit('PERFILE_UPDATE_SELECT_KEY', data);
    }
  }
};

export default perFile;
